import { render } from "./Departement.vue?vue&type=template&id=41164987&scoped=true"
import script from "./Departement.vue?vue&type=script&lang=js"
export * from "./Departement.vue?vue&type=script&lang=js"

import "./Departement.vue?vue&type=style&index=0&id=41164987&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41164987"]])

export default __exports__